import React from "react";
import Typography from "@material-ui/core/Typography";
import SnackbarAlert from "../components/SnackbarAlert";
import {panelGeneralResources} from "../endpoints";
import TablaPanelGeneral from "../components/TablaPanelGeneral";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";

class PanelGeneral extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openSnack:false,
            severity: null,
            message:null,
            disponibles:[],
            totalRecords: 0,
            loading: false,
            page: 0,
            pageSize: 25,
            searchQuery: "",
            sortField: "fecha",
            sortDir: "desc"
        }
        this.searchTimeout = null;
    }

    componentDidMount(){
        this.obtenerDatos()
    }

    obtenerDatos = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        panelGeneralResources.getInventariosPanelGeneral(
            this.state.page,
            this.state.pageSize,
            this.state.searchQuery,
            this.state.sortField,
            this.state.sortDir
        ).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(data => {
            if (data.status_code === 200) {
                this.setState({
                    disponibles: data.inv_disponibles,
                    totalRecords: data.total_records || 0,
                    loading: false
                });
            } else if (data.status_code === 401) {
                this.setState({
                    openSnack: true,
                    severity: data.severity,
                    message: data.message,
                    loading: false
                });
            } else {
                throw new Error("Something went wrong ...");
            }
        }).catch(error=> {
            console.error(error);
            this.setState({ loading: false });
        });
    }

     handleSearchChange = (event) => {
        const valor = event.target.value;
        this.setState({ searchQuery: valor });

        if (this.searchTimeout) clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
            this.setState({ paginationModel: { ...this.state.paginationModel, page: 0 } }, () => {
                this.obtenerDatos();
            });
        }, 600);
    }

    handlePageChange = (newPage, newPageSize) => {
        this.setState({ page: newPage, pageSize: newPageSize }, () => this.obtenerDatos());
    };

    handleSortChange = (field, dir) => {
        this.setState({ sortField: field, sortDir: dir, page: 0 }, () => this.obtenerDatos());
    };

    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>
                    Panel de control
                </Typography>

                {/* Buscador personalizado */}
                <div style={{ marginBottom: 16, maxWidth: 400 }}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        placeholder="Buscar cliente, tienda, folio, estado..."
                        value={this.state.searchQuery}
                        onChange={this.handleSearchChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon color="action" />
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>

                <TablaPanelGeneral
                    disponibles={this.state.disponibles}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    page={this.state.page}
                    pageSize={this.state.pageSize}
                    onPageChange={this.handlePageChange}
                    onSortChange={this.handleSortChange}
                />

                {this.state.openSnack ? (
                    <SnackbarAlert severity={this.state.severity} message={this.state.message} />
                ) : null}
            </div>
        )
    }
}

export default PanelGeneral;